<template>
  <div class="main-content">
    <div>
      <buttonItem :buttonList="menuButtonList" @chooseClick="clickEvent"></buttonItem>
    </div>
    <div class="public-table">
      <vxe-grid
        ref="allocation"
        border
        resizable
        show-overflow
        size="mini"
        height="500"
        :data="tableData"
        :edit-rules="editRules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
      >
        <vxe-table-column type="seq" width="60"></vxe-table-column>
        <vxe-table-column
          field="firstIndexCode"
          title="一级指标"
          :edit-render="{ name: 'ElSelect', options: indexList }"
        ></vxe-table-column>
        <vxe-table-column
          field="secondIndexName"
          title="二级指标"
          :edit-render="{ name: 'ElInput', attrs: { type: 'text', maxlength: '100' } }"
        ></vxe-table-column>
        <vxe-table-column
          field="thirdIndexName"
          title="三级指标"
          :edit-render="{ name: 'ElInput', attrs: { type: 'text', maxlength: '100' } }"
        ></vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import buttonItem from '../../../../components/ButtonItem';
  export default {
    name: 'indicatorsAllocation',
    components: {
      buttonItem,
    },
    mounted() {
      this.getButtonList();
      this.getData();
      this.$axios
        .post('/maindata/dictData/listDataDictByDataType', { dictType: 'LEVEL_1_INDEX' })
        .then((res) => {
          this.indexList = res.data.data;
        });
    },
    data() {
      return {
        tableData: [],
        indexList: [],
        menuButtonList: [],
        editRules: {
          first: [{ required: true, trigger: 'change', message: '请输入' }],
          second: [{ required: true, message: '请输入' }],
          three: [{ required: true, message: '请输入' }],
        },
      };
    },
    methods: {
      getData() {
        this.$axios.post('/sales/creditLimitEngineIndex/list').then((res) => {
          this.tableData = res.data.data;
        });
      },
      clickEvent(type) {
        if (type === 'add') {
          this.$refs.allocation.commitProxy('insert_actived');
        } else if (type === 'save') {
          this.save();
        }
      },
      save() {
        let params = this.$refs.allocation.getTableData().fullData;
        params.forEach((item) => {
          if (!item.firstIndexName) {
            this.indexList.forEach((item2) => {
              if (item2.value === item.firstIndexCode) {
                item.firstIndexName = item2.label;
              }
            });
          }
        });
        this.$axios.post('/sales/creditLimitEngineIndex/save', params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
            });
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      getButtonList() {
        this.getButtons().then((e) => {
          console.log(e);
          this.menuButtonList = e;
        });
      },
    },
  };
</script>

<style scoped></style>
